<template>
    <transition name="modal-animation">
        <div v-show="modalActive" class="modal">
            <transition name="modal-animation-inner">
                <div v-show="modalActive" class="modal-inner">
                    <h4 class="modal-heading">Create Training</h4>
                    <hr class="my-0 mb-2" />
                    <div class="row">
                        <div class="col-6">
                            <Input
                                placeholder="Training Name "
                                label="Training Name *"
                                v-model="training.trainingName"
                            />
                        </div>
                        <div class="col-6">
                            <p class="my-1 label">Training Image (optional)</p>
                            <div v-if="training.trainingImg">
                                <img :src="training.trainingImg" alt="profile-image" class="training-image" />
                            </div>
                            <input type="file" @change="onFilePicked" class="mt-3" />
                        </div>
                        <div class="col-12 mt-3">
                            <p class="my-1 label">Description *</p>
                            <vue-editor
                                id="text-editor"
                                v-model="training.description"
                                :editorOptions="customEditorOptions"
                            ></vue-editor>
                        </div>
                        <div class="row p-2">
                            <div class="col-6">
                                <SearchDropDown
                                    label="Select Trainer *"
                                    :selectLabel="trainer.name || 'Select Trainer'"
                                    placeholder="Enter Trainer Name to search"
                                    v-model="trainerSearchTerm"
                                    @callBackValue="handleTrainerChange"
                                    :items="userListOption"
                                />
                            </div>
                            <div class="col-6">
                                <p class="my-1 label">Reporters (optional)</p>

                                <multiselect
                                    class="m-0"
                                    v-model="training.reporters"
                                    placeholder="Search for Reporter"
                                    label="name"
                                    track-by="id"
                                    :options="reporteeListOption"
                                    @search-change="onChange"
                                    :multiple="true"
                                ></multiselect>

                                <!-- <VueMultiselectComponent
                  v-model="training.reporters"
                  :options="reporteeListOption"
                  placeholder="Search Reporter"
                  :writable="true"
                  :searchable="true"
                  @search-change="onChange"
                  @selected="onChange('')"
                  @open="onChange('')"
                />

                <VueMultiselectComponent
                  v-model="training.users"
                  :options="userListOption"
                  placeholder="Search for employee name"
                  @search-change="onChange"
                /> -->
                            </div>
                        </div>
                        <div class="info-box mx-2 my-2">
                            <p class="my-0 fade-text"><font-awesome-icon icon="fa-solid fa-circle-info" /> Instructions to create a Training</p>
                            <li>Select a module from the right section below</li>
                            <li>Drag Tasks from module section into day</li>
                            <li>Click +Add Day to add a day in the training</li>
                            <!-- <li>click add day button </li> -->
                        </div>


                        <div class="row">
                            <div class="col-7">
                                <div class="row mb-1 p-1 me-1 justify-content-end">
                                    <p class="add-day-title" @click="addDay()">
                                        <font-awesome-icon icon="fa-solid fa-plus" /> Add Day
                                    </p>
                                </div>
                                <div class="day-body p-1">
                                    <div v-for="(day, index) in training.trainingSessions" :key="index">
                                        <div class="d-flex justify-content-between day-header p-2">
                                            <div class="my-0 sub-heading">Day {{ index + 1 }}</div>
                                            <div class="sub-heading">
                                                <font-awesome-icon icon="fa-solid fa-trash" @click="deleteDay(index)" />
                                            </div>
                                        </div>
                                        <draggable
                                            :group="{ name: 'day', pull: false, put: true }"
                                            v-model="day.tasks"
                                            @change="validateTaskList(day.tasks, index)"
                                        >
                                            <div class="task-list m-2">
                                                <Card
                                                    v-for="(data, taskindex) in day.tasks"
                                                    :key="taskindex"
                                                    class="task my-2 p-2 normal-text"
                                                >
                                                    {{ data.title }}
                                                    <font-awesome-icon
                                                        icon="fa-solid fa-circle-xmark"
                                                        class="float-end mt-1"
                                                        @click="deleteTask(index, taskindex)"
                                                    />
                                                </Card>
                                                <div
                                                    class="drop d-flex justify-content-center align-items-center"
                                                    v-if="day.tasks.length === 0"
                                                >
                                                    <p class="placeholder-card-title m-0">
                                                        <font-awesome-icon icon="fa-solid fa-download" />
                                                        Drop Task Here.
                                                    </p>
                                                </div>
                                            </div>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="px-0 assign-body">
                                    <SearchDropDown
                                        label="Select Module *"
                                        :selectLabel="selectedModule.name || 'Select Module'"
                                        placeholder="Enter Module to search"
                                        v-model="moduleSearchTerm"
                                        @callBackValue="handleFilterModule"
                                        :items="moduleList"
                                    />
                                </div>

                                <div class="task-list-area p-2">
                                    <draggable :list="taskList" :group="{ name: 'day', pull: 'clone', put: false }">
                                        <Card
                                            v-for="(task, index) in taskList"
                                            :key="index"
                                            class="bill-board-entity mb-2 normal-text"
                                        >
                                            <div class="d-flex m-2 justify-content-between">
                                                <div>
                                                    <p class="bill-board-entity-title my-0">
                                                        {{ task.title }}
                                                    </p>
                                                </div>
                                                <div><font-awesome-icon icon="fa-solid fa-bars" /></div>
                                            </div>
                                        </Card>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                        <!-- <Button label="Assign" class="qb-btn qb-btn-primary-md col-3 " /> -->
                    </div>

                    <Button label="Create" class="qb-btn qb-btn-primary-md col-3" @onClick="assign()" />
                    <Button label="Close" class="qb-btn qb-btn-outline-md ms-2" @onClick="close" />
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue';
import draggable from 'vuedraggable';
import { VueEditor } from 'vue2-editor';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapModuleActions, mapGetters } = createNamespacedHelpers('Module');
const { mapGetters: userMapGetters, mapActions: userMapActions } = createNamespacedHelpers('User');
const { mapGetters: mapAuthGetters } = createNamespacedHelpers('Auth');
const { mapActions: mapTrainingActions } = createNamespacedHelpers('Training');
import SearchDropDown from './DropDownSearchComponent.vue';
// import VueMultiselectComponent from "vue-multiselect-component";
import Multiselect from 'vue-multiselect';
import Input from './TextFieldComponent.vue';
import Button from './ButtonComponent.vue';
import Card from '../components/CardComponent.vue';
export default {
    name: 'BulkAssign',
    data() {
        return {
            customEditorOptions: {
                placeholder: 'Enter Description',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['code-block'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ script: 'sub' }, { script: 'super' }],
                        [{ indent: '-1' }, { indent: '+1' }],
                        [{ align: [] }],
                        ['clean'],
                    ],
                },
            },
            training: {
                trainingName: '',
                trainingImg: '',
                description: '',
                reporters: [],
                trainerId: '',
                modules: [],
                categories: [],
                createdBy: '',
                trainingSessions: [{ day: 'DAY_1', tasks: [] }],
            },
            trainer: {
                id: '',
                name: '',
            },
            moduleSearchTerm: '',
            trainerSearchTerm: '',
            selectedModule: {
                id: '',
                name: '',
            },
        };
    },
    props: {
        modalActive: {
            type: Boolean,
        },
    },

    components: {
        Input,
        // WorkSheetEntityPage,
        SearchDropDown,
        // VueMultiselectComponent,
        Multiselect,
        draggable,
        Button,
        Card,
        VueEditor,
    },
    methods: {
        ...mapModuleActions({
            getTaskByModuleId: 'GET_ALL_TASK_BY_MODULE_ID',
            getAllModule: 'GET_ALL_MODULE',
        }),
        ...userMapActions({
            bulkassign: 'BULK_ASSIGN_WORKSHEET',
            getAssigneeList: 'GET_ASSIGNEE_LIST',
            getUserList: 'GET_USER_LIST',
            getEmployeeList: 'GET_EMPLOYEE_LIST',
        }),
        ...mapTrainingActions({
            createTraining: 'CREATE_TRAINING',
        }),
        handleFilterModule({ label, value }) {
            this.selectedModule.name = label;
            this.selectedModule.id = value;
            this.getTaskByModuleId(value);
        },
        handleTrainerChange({ label, value }) {
            this.trainer.name = label;
            this.trainer.id = value;
            this.training.trainerId = value;
            // this.populateToReporters({ label, value });
        },
        populateTrainerWithReporters() {
            const temp = this.training.reporters.find((item) => item.id === this.trainer.id);
            if (!temp) {
                this.training.reporters.push({ id: this.trainer.id, name: this.trainer.name });
            }
        },
        structureReporters() {
            let flag=0;
            const temp = this.training.reporters.map((item) => {
                if(item.id==this.user.userId){
                    flag=flag+1;
                }
                return item.id;
            });
            if(flag==0 && this.trainerId!=this.user.userId){
            temp.push(this.user.userId)
            }
            return temp;
        },
        onChange(name) {
            this.getEmployeeList({ name });
        },

        addDay() {
            this.training.trainingSessions.push({
                day: 'Day_' + (this.training.trainingSessions.length + 1),
                tasks: [],
            });
        },
        deleteDay(index) {
            this.training.trainingSessions.splice(index, 1);
        },
        deleteTask(index, taskindex) {
            this.training.trainingSessions[index].tasks.splice(taskindex, 1);
        },
        validateTaskList(data, index) {
            console.log(data)
            const temp = data.filter((item, i) => {
                return data.findIndex((item2) => item2.id === item.id) === i;
            });
            this.training.trainingSessions[index].tasks = temp;
        },
        close() {
            this.clearTraining();
            this.$emit('close');
        },
        clearTraining() {
            this.training = {
                trainingName: '',
                trainingImg: '',
                description: '',
                reporters: [],
                trainerId: '',
                modules: [],
                categories: [],
                createdBy: '',
                trainingSessions: [{ day: 'DAY_1', tasks: [] }],
            };
        },
        onFilePicked(event) {
            const files = event.target.files;
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => (this.training.trainingImg = reader.result);
        },
        removeDuplicates(arr) {
            return [...new Set(arr)].filter(Boolean);
        },
        assign() {
            // const moduleIdList = [];

            this.training.trainingSessions.map((data) => {
                data.tasks.map((task) => {
                    this.training.modules.push(task.moduleId);
                    this.training.categories.push(task.categoryId);
                });
            });

            let count = 0;
            const structuredTrainingSessions = this.training.trainingSessions
                .map((day) => {
                    return (
                        day.tasks.length > 0 && {
                            day: 'DAY_' + ++count,
                            tasks: day.tasks.map((task) => {
                                return task.id;
                            }),
                        }
                    );
                })
                .filter(Boolean);

            this.training.modules = this.removeDuplicates(this.training.modules);
            this.training.categories = this.removeDuplicates(this.training.categories);
            const { trainingSessions, createdBy, reporters, ...rest } = this.training;

            console.log(trainingSessions, createdBy, reporters);
            console.log(rest);
            console.clear()

            this.populateTrainerWithReporters();
            if(structuredTrainingSessions.length==0){
                Vue.$toast.error("Drag tasks from module section to days")
            } else {
            this.createTraining({
                payload: {
                    ...rest,
                    reporters: this.structureReporters(),
                    trainingSessions: structuredTrainingSessions,
                    createdBy: this.user.userId,
                },
                successCallback: ({ data }) => {
                    if (data.status === 'OK') {
                        // Vue.$toast.success('Worksheet Created Successfully');

                        this.$emit('close');
                        this.$router.push({
                            name: 'TrainingDescriptionPage',
                            params: { id: data.data.id },
                        });
                    } else {
                        Vue.$toast.error('Worksheet Created Failed');
                    }
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });}
        },
    },
    computed: {
        ...mapGetters({
            moduleList: 'getModuleListOptions',
            taskList: 'getTaskList',
        }),
        ...userMapGetters({
            userList: 'getUserList',
            userListOption: 'getUserListOption',
            reporteeListOption: 'getUserListOptionForBulkAssign',
            assigneeList: 'getAssigneeList',
            //   selectedUser: "getSelectedUser",
        }),
        ...mapAuthGetters({
            user: 'getUser',
        }),
    },
    watch: {
        trainerSearchTerm(name) {
            this.getUserList({ name });
        },
        moduleSearchTerm(name) {
            this.getAllModule({ name });
        },
    },
    created() {
        this.getAssigneeList({ name: '', designation: this.user.designation });
        // this.getAllModule({ name: "" });
        this.getUserList({ name: '' });
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';
.fa-trash,
.fa-circle-xmark {
    cursor: pointer;
    color: rgb(144, 144, 144);
}
.day-header {
    background-color: $light-200;
    border-radius: $field-border-radius;
}
.task {
    border-radius: $field-border-radius;
}
.sub-heading {
    font-size: $font-size-sm;
    font-weight: 600;
}
.normal-text {
    font-size: $font-size-sm;
    font-weight: 500;
}
.task-list {
    border-radius: $field-border-radius;
    // border:1px solid rgb(229, 229, 229);
}
.assign-body {
    width: 100%;
}
.drop {
    width: 100%;
    height: 40px;
    border-radius: $field-border-radius;
    border: 1px dashed $light-300;
    padding: 5px 0px;
    background-color: $white;
}
.placeholder-card-title {
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-2;
    color: $light-400;
}
.day-body {
    max-height: 300px;
    overflow: scroll;
}

.day-body::-webkit-scrollbar {
    background: none;
    height: 0px;
    width: 5px;
}

.day-body::-webkit-scrollbar-thumb {
    background-color: $border-color;
    border-radius: $field-border-radius;
}
.bill-board-entity {
    cursor: move;
}
.label {
    font-weight: $font-weight-normal-2;
    font-size: $font-size-md;
    // margin-top: 10px;
    margin-bottom: 10px;
}

.add-day-title {
    font-size: $font-size-sm;
    margin: 0px;
    font-weight: $font-weight-normal-2;
    color: $dark-300;
    background-color: $light-fade-200;
    padding: 5px 10px;
    border-radius: $field-border-radius;
    width: max-content;
    &:hover {
        background-color: $light-200;
        cursor: pointer;
    }
}
.task-list-area {
    height: 300px;
    overflow: scroll;
    border-radius: $field-border-radius;
    background-color: $light-fade-100;
    margin-top: 10px;
}

.modal-animation-enter-active,
.modal-animation-leave-active {
    transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-enter-from,
.modal-animation-leave-to {
    opacity: 0;
}
.modal-animation-inner-enter-active {
    transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}
.modal-animation-inner-leave-active {
    transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-inner-enter-from {
    opacity: 0;
    transform: scale(0.8);
}
.modal-animation-inner-leave-to {
    transform: scale(0.8);
}

.modal {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(9, 30, 66, 0.54);
    .modal-inner {
        position: relative;
        max-width: 650px;
        margin-top: 70px;
        margin-bottom: 100px;
        width: 80%;
        background-color: #fff;
        border-radius: $field-border-radius;
        padding: 30px;
    }
}

.training-image {
    width: 200px;
    margin-right: 10px;
}
.fade-text{
    color:$light-600;
    font-size: $font-size-sm;
}
.info-box{
    color: $light-500;
    font-weight: $font-weight-bold;
    font-size: $font-size-sm;
    border:none;
    border-left:3px solid rgb(55, 55, 52);
    // border-radius:9px;
}
</style>
